import { aboutInfo } from '@/mocks/animeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[800px] mx-auto">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-6 md:mb-8 text-center">
            {aboutInfo.title}
          </h2>

          <div className="space-y-4">
            {aboutInfo.paragraphs.map((paragraph, idx) => (
              <p
                key={idx}
                className="text-sm md:text-base text-foreground-600 leading-relaxed"
              >
                {paragraph}
              </p>
            ))}
          </div>

          <div className="mt-8 md:mt-10 flex flex-wrap justify-center gap-6 md:gap-10">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-primary-500">5年+</div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1">稳定运营</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-accent-500">800万+</div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1">漫友信赖</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-secondary-500">99.9%</div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1">服务可用</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}